module.exports = __webpack_public_path__ + "img/she.3b18d4d9.jpg";